import { Navigate, useLocation } from "react-router-dom";

/**
 * Component to handle redirects from legacy MVP routes to new routes
 * Preserves path segments and query parameters
 *
 * Example redirects:
 * - /data-commons -> /materials-database
 * - /data-commons/recipe/123 -> /materials-database/recipe/123
 * - /data-commons/recipe/123?query=test -> /materials-database/recipe/123?query=test
 * - /data-commons/recipe/123#hash -> /materials-database/recipe/123#hash
 *
 * @param from - The legacy route prefix to match (e.g., "/data-commons")
 * @param to - The new route prefix to redirect to (e.g., "/agar-stack/materials-database")
 */
interface LegacyRedirectProps {
  from: string;
  to: string;
}

export function LegacyRedirect({ from, to }: LegacyRedirectProps) {
  const location = useLocation();

  // Extract the path after the "from" prefix
  const remainingPath = location.pathname.replace(from, "");

  // Construct the new path
  const newPath = `${to}${remainingPath}`;

  return <Navigate to={newPath + location.search + location.hash} replace />;
}
